var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4856 0.125843C10.1836 -0.0419476 9.81638 -0.0419476 9.51436 0.125843L0.514357 5.12584L0.507297 5.13784L0.492872 5.13802C0.187494 5.3177 0 5.64568 0 6V15.9999C0 16.3631 0.196892 16.6977 0.514357 16.874L9.50218 21.8673C9.8059 22.0416 10.1791 22.0445 10.4856 21.8742L19.4856 16.8742C19.8031 16.6978 20 16.3632 20 16V6C20 5.64568 19.8125 5.31781 19.5071 5.13813C19.4996 5.13372 19.4921 5.12942 19.4845 5.12522L10.4856 0.125843ZM3.05923 5.99995L10.0001 9.85599L12.4855 8.47519L5.74296 4.50898L3.05923 5.99995ZM14.5142 7.34816L16.9409 6L10 2.14396L7.77162 3.38195L14.5142 7.34816ZM2 15.4115V7.69951L9 11.5884V19.3004L2 15.4115ZM11 19.3005V11.5884L18 7.69951V15.4116L11 19.3005Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.15e13a1a54f00718283d3b1cecf725fd.svg";
export { ForwardRef as ReactComponent };